import { NgModule } from "@angular/core";
import { ModalComponent } from "src/app/components/modal/modal.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule
    ],
    declarations: [ModalComponent],
    exports: [ModalComponent]
})
export class ModalComponentModule {}